<template>
  <TapEdit/>
</template>

<script setup lang="ts">
import TapEdit from '@/components/TapEdit.vue'
import { useTapStore } from '@/stores/tapStore';
import {useI18n} from "vue-i18n";


const config = useRuntimeConfig()
const host = config.public.tapLink;
const tapStore = useTapStore();

useSeoMeta({
  title: () => tapStore.currentTapLang?.name || 'Tap Telecom',
  ogTitle: () => tapStore.currentTapLang?.name || 'Tap Telecom',
  description: () => tapStore.currentTapLang?.description || '',
  ogDescription: () => tapStore.currentTapLang?.description || '',
  // Ссылка на сгенерированную картинку
  ogImage: () =>  tapStore.currentTap?.image ? `https://${host}${tapStore.currentTap?.image}` : '/preview.png',
  twitterCard: 'summary_large_image',
});

const { locale } = useI18n()
 useHead({
   htmlAttrs: {
     lang: locale
   }
})
</script>

<style scoped lang="sass">
.fix
  display: flex

</style>
